import { useState, useMemo, useRef, useCallback, useEffect } from 'react'

//* Helpers
import { api, config } from 'helpers'

//* Components
import { AutoComplete, Form, Input } from 'antd'
import { Icon, Text, ButtonTag } from 'components/common'

//* Style
import TagFilterStyle from './style'

const TagFilter = ({ filter, formRef }) => {
    const [activeTag, setActiveTag] = useState()
    const [selectedTag, setSelectedTag] = useState()
    const [tags, setTags] = useState([])
    const [options, setOptions] = useState([])
    const [data, setData] = useState([])

    //! Refs
    const wrapRef = useRef()

    useEffect(async () => {
        await api.get(`${config.routePrefix.tags}/for-filter`).then(res => {
            setTags(res)
            setData(res)
        })
    }, [])

    useEffect(() => {
        if (filter.tag == undefined) {
            setActiveTag(null)
        }
    }, [filter.tag])

    useEffect(() => {
        const newOptions = []

        data.map((option) => {
            newOptions.push({
                value: option.name,
                key: option.id,
            })
        })

        setOptions(newOptions)
    }, [data])

    useEffect(() => {
        setActiveTag(tags.find(item => item.id == selectedTag)?.name)
    }, [selectedTag])

    const onSearch = useCallback((value) => {
        const filtered = tags.filter((entry) => Object.values(entry).some((val) => typeof val === 'string' && val.toLowerCase().includes(value.toLowerCase())))
        setData(filtered)
        setActiveTag(value)
    }, [tags])

    const onSelect = useCallback((_, option) => {
        formRef?.current.setFields([
            {
                name: 'tag',
                value: option.key
            }
        ])

        setSelectedTag(option.key)
    }, [tags])

    const selectTag = useCallback((id) => {
        formRef?.current.setFields([
            {
                name: 'tag',
                value: id
            }
        ])
        setSelectedTag(id)
    }, [tags])

    const storeSkills = useMemo(() => {
        return tags.slice(0, 4)?.map((i, k) => (
            <ButtonTag
                onClick={() => selectTag(i.id)}
                key={k}
                cssClass='black'
                parentClass="smallTag"
                bordered
                content={i.name}
            />
        ))
    }, [tags])

    return (
        <TagFilterStyle ref={wrapRef}>
            <Text tag='h5' className='h5 PopSemi ant-form-item-label' text='Topics' />
            <div className={`search loggedIn`}>
                <div className={'ant-form-item'}>
                    <Form.Item name={'tag'} noStyle>
                        <Input type={'hidden'} />
                    </Form.Item>
                    <AutoComplete
                        options={options}
                        onSelect={onSelect}
                        onSearch={onSearch}
                        getPopupContainer={() => wrapRef?.current}
                        value={activeTag}
                    >
                        <Input
                            suffix={<Icon className={'op-search grey'} />}
                            className='input-text'
                        />
                    </AutoComplete>
                </div>
                <div className='popular-topics flexBox alignMiddle'>
                    <Text tag='p' className='h7 PopReg tit' text='Popular topics:' />
                    {storeSkills}
                </div>
            </div>
        </TagFilterStyle>
    )
}

export default TagFilter